import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { routes } from '@/lib/routes';
import HomePage from './HomePage';

/** B01-A01 — first open shows login; shell home is post-auth only. */
const HomeGate = () => {
  const { user } = useAuth();
  if (!user) return <Navigate to={routes.login} replace />;
  return <HomePage />;
};

export default HomeGate;
